"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveNamespace = void 0;
// Namespace Resolver
var core_1 = require("@stylable/core");
function noCollisionNamespace(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.prefix, prefix = _c === void 0 ? '' : _c, _d = _b.used, usedNamespaces = _d === void 0 ? new Map() : _d;
    return function (namespace, stylesheetPath) {
        var ns = prefix + namespace;
        if (ns.startsWith('steindex'))
            return core_1.processNamespace(ns, stylesheetPath);
        var used = usedNamespaces.get(ns);
        if (used) {
            if (used.stylesheetPath !== stylesheetPath) {
                throw Error("namespace (" + ns + " of " + stylesheetPath + ") is already in use by " + used.stylesheetPath);
            }
        }
        else {
            usedNamespaces.set(ns, { prefix: prefix, namespace: namespace, stylesheetPath: stylesheetPath });
        }
        return ns;
    };
}
exports.resolveNamespace = noCollisionNamespace({ prefix: 'ste' });
//# sourceMappingURL=namespace-resolver.js.map